export default {"src":"//jsak.mmtcdn.com/tripmoney/apps/landing-pages/_next/static/media/QuickLinks.db19e1dd.svg","height":21,"width":20};